export enum WhiteLabel {
  Refrain = 'refrain',
  SerresTessier = 'serrestessier',
  Mutuo = 'mutuo',
  HauteGaspesie = 'hautegaspesie',
}
